import { observer } from 'mobx-react-lite'
import { CLICK_TO_TEXT_NAME_LIMIT } from 'shared/constants/limits'
import { TextInput } from 'shared/ui'
import { useClickToTextViewContext } from 'pages/clickToText/pages/viewClickToText/context'
import styles from './styles.module.scss'

export const ClickToTextName = observer(() => {
  const { setName, name, errorsMap, removeError } = useClickToTextViewContext()

  const error = errorsMap.get('name')

  return (
    <TextInput
      size={'large'}
      placeholder={'Link name'}
      value={name}
      setValue={setName}
      error={error}
      limit={CLICK_TO_TEXT_NAME_LIMIT}
      onFocus={() => removeError('name')}
      className={styles.name}
      ariaLabel='LinkName'
    />
  )
})
